"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./style.scss");
var React = __importStar(require("react"));
var Forms_1 = require("../../Components/Forms");
var DOMPurify = __importStar(require("dompurify"));
var GMap_1 = __importDefault(require("./GMap"));
var BMap_1 = __importDefault(require("./BMap"));
var client_1 = require("react-dom/client");
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);
    };
}
var DTCTechTable = /** @class */ (function (_super) {
    __extends(DTCTechTable, _super);
    function DTCTechTable(props) {
        return _super.call(this, props) || this;
    }
    DTCTechTable.prototype.checkFilter = function (filters, tech) {
        var pass = true;
        if (filters.product != "" &&
            filters.product != "none" &&
            !tech.Products.includes(filters.product)) {
            pass = false;
        }
        if (filters.region != "" &&
            filters.region != "none" &&
            !tech.Region.includes(filters.region)) {
            pass = false;
        }
        return pass;
    };
    DTCTechTable.prototype.renderTableBody = function (filters, tech, index) {
        if (this.checkFilter(filters, tech)) {
            return (React.createElement("tr", { key: index },
                React.createElement("td", null,
                    tech.Products.toString(),
                    " "),
                React.createElement("td", null,
                    tech.Company,
                    " "),
                React.createElement("td", null,
                    tech.Country,
                    " "),
                React.createElement("td", null,
                    tech.State,
                    " "),
                React.createElement("td", null,
                    tech.City,
                    " "),
                React.createElement("td", null,
                    React.createElement("a", { href: "tel:".concat(tech.Phone) },
                        " ",
                        tech.Phone)),
                this.props.baiduMode ? (React.createElement(React.Fragment, null)) : (React.createElement("td", null,
                    React.createElement("a", { target: "_blank", href: "https://www.google.com/maps/search/?api=1&query=".concat(tech.Location.lat, ",").concat(tech.Location.lng) }, "Address")))));
        }
        else {
            return null;
        }
    };
    DTCTechTable.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "scroll-auto mb-80" },
            React.createElement("table", { className: "df-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            " ",
                            this.props.pageTranslations.Products,
                            " "),
                        React.createElement("th", null,
                            " ",
                            this.props.pageTranslations.Company),
                        React.createElement("th", null,
                            " ",
                            this.props.pageTranslations.Country,
                            " "),
                        React.createElement("th", null,
                            " ",
                            this.props.pageTranslations.State,
                            " "),
                        React.createElement("th", null,
                            " ",
                            this.props.pageTranslations.City,
                            " "),
                        React.createElement("th", null,
                            " ",
                            this.props.pageTranslations.Phone,
                            "  "),
                        this.props.baiduMode ? React.createElement(React.Fragment, null) : React.createElement("th", null,
                            " ",
                            this.props.pageTranslations.Directions,
                            " "))),
                React.createElement("tbody", null, this.props.techs.map(function (tech, index) {
                    return _this.renderTableBody(_this.props.filters, tech, index);
                })))));
    };
    return DTCTechTable;
}(React.Component));
var DTCPage = /** @class */ (function (_super) {
    __extends(DTCPage, _super);
    function DTCPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedProducts: "",
            selectedRegions: "",
            openInfoIndex: -1,
            geolocationCenter: { lat: 36.0, lng: -94.0 },
            geolocationZoom: 3,
            techsInView: props.techs,
        };
        if (!_this.props.listMode && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                _this.setState({
                    geolocationCenter: {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    },
                    geolocationZoom: 6,
                });
            });
        }
        _this.handleProductChange = _this.handleProductChange.bind(_this);
        _this.handleRegionChange = _this.handleRegionChange.bind(_this);
        _this.handleMapMarkerClick = _this.handleMapMarkerClick.bind(_this);
        _this.handleDropdownReset = _this.handleDropdownReset.bind(_this);
        return _this;
    }
    DTCPage.prototype.handleRegionChange = function (event) {
        this.setState({ selectedRegions: event.target.value });
    };
    DTCPage.prototype.handleProductChange = function (event) {
        this.setState({ selectedProducts: event.target.value });
    };
    DTCPage.prototype.handleMapMarkerClick = function (index) {
        this.setState({ openInfoIndex: index });
    };
    DTCPage.prototype.handleBoundsChanged = function (map) {
        var bounds = map.getBounds();
        var techsInBounds = [];
        this.props.techs.map(function (tech, index) {
            if (bounds.contains({
                lat: tech.Location.lat,
                lng: tech.Location.lng,
            })) {
                techsInBounds.push(tech);
            }
        });
        this.setState({ techsInView: techsInBounds });
    };
    DTCPage.prototype.handleBoundsChangedBaidu = function (sw, ne) {
        var techsInBounds = [];
        this.props.techs.map(function (tech, index) {
            if (tech.Location.lat >= sw.lat &&
                tech.Location.lat <= ne.lat &&
                tech.Location.lng >= sw.lng &&
                tech.Location.lng <= ne.lng) {
                techsInBounds.push(tech);
            }
        });
        this.setState({ techsInView: techsInBounds });
    };
    DTCPage.prototype.handleDropdownReset = function (event) {
        this.setState({ selectedRegions: '' });
        this.setState({ selectedProducts: '' });
    };
    DTCPage.prototype.showAlertPanel = function (safeHTML, showInfoSection, infoPanelAlerts) {
        if (showInfoSection) {
            switch (infoPanelAlerts) {
                case 'Info alert':
                    return (React.createElement("div", { className: "df-alert alert-info", role: "alert" },
                        React.createElement("span", { className: "df-icon df-alert-icon" },
                            React.createElement("title", null, "Success alert"),
                            React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPgoJPHRpdGxlPmFsZXJ0LWluZm8tc3ZnPC90aXRsZT4KCTxzdHlsZT4KCQkuczAgeyBmaWxsOiAjNDZiOWYzIH0gCgk8L3N0eWxlPgoJPHBhdGggaWQ9IkxheWVyIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsYXNzPSJzMCIgZD0ibTIyIDEyYzAgNS41LTQuNSAxMC0xMCAxMC01LjUgMC0xMC00LjUtMTAtMTAgMC01LjUgNC41LTEwIDEwLTEwIDUuNSAwIDEwIDQuNSAxMCAxMHptLTIgMGMwLTQuNC0zLjYtOC04LTgtNC40IDAtOCAzLjYtOCA4IDAgNC40IDMuNiA4IDggOCA0LjQgMCA4LTMuNiA4LTh6bS05LTVoMnYyaC0yem0wIDRoMnY2aC0yeiIvPgo8L3N2Zz4=" })),
                        React.createElement("div", { className: "df-alert-message" },
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: safeHTML } }))));
                case 'Warning alert':
                    return (React.createElement("div", { className: "df-alert alert-warning", role: "alert" },
                        React.createElement("span", { className: "df-icon df-alert-icon" },
                            React.createElement("title", null, "Success alert"),
                            React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPgoJPHRpdGxlPmFsZXJ0LWluZm8tc3ZnPC90aXRsZT4KCTxzdHlsZT4KCQkuczAgeyBmaWxsOiAjZmZhYTAwIH0gCgk8L3N0eWxlPgoJPHBhdGggaWQ9IkxheWVyIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsYXNzPSJzMCIgZD0ibTIyIDEyYzAgNS41LTQuNSAxMC0xMCAxMC01LjUgMC0xMC00LjUtMTAtMTAgMC01LjUgNC41LTEwIDEwLTEwIDUuNSAwIDEwIDQuNSAxMCAxMHptLTIgMGMwLTQuNC0zLjYtOC04LTgtNC40IDAtOCAzLjYtOCA4IDAgNC40IDMuNiA4IDggOCA0LjQgMCA4LTMuNiA4LTh6bS05LTVoMnYyaC0yem0wIDRoMnY2aC0yeiIvPgo8L3N2Zz4=" })),
                        React.createElement("div", { className: "df-alert-message" },
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: safeHTML } }))));
                case 'Success alert':
                    return (React.createElement("div", { className: "df-alert alert-success", role: "alert" },
                        React.createElement("span", { className: "df-icon df-alert-icon" },
                            React.createElement("title", null, "Success alert"),
                            React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPgoJPHRpdGxlPmFsZXJ0LXN1Y2Nlc3Mtc3ZnPC90aXRsZT4KCTxzdHlsZT4KCQkuczAgeyBmaWxsOiAjMTRjNTEwIH0gCgk8L3N0eWxlPgoJPHBhdGggaWQ9IkxheWVyIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsYXNzPSJzMCIgZD0ibTIyIDEyYzAgNS41LTQuNSAxMC0xMCAxMC01LjUgMC0xMC00LjUtMTAtMTAgMC01LjUgNC41LTEwIDEwLTEwIDUuNSAwIDEwIDQuNSAxMCAxMHptLTIgMGMwLTQuNC0zLjYtOC04LTgtNC40IDAtOCAzLjYtOCA4IDAgNC40IDMuNiA4IDggOCA0LjQgMCA4LTMuNiA4LTh6bS0yLTNsLTggOC00LTQgMS40LTEuNCAyLjYgMi42IDYuNi02LjZ6Ii8+Cjwvc3ZnPg==" })),
                        React.createElement("div", { className: "df-alert-message" },
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: safeHTML } }))));
                case 'Error alert':
                    return (React.createElement("div", { className: "df-alert alert-error", role: "alert" },
                        React.createElement("span", { className: "df-icon df-alert-icon" },
                            React.createElement("title", null, "Success alert"),
                            React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPgoJPHRpdGxlPmFsZXJ0LWVycm9yLXN2ZzwvdGl0bGU+Cgk8c3R5bGU+CgkJLnMwIHsgZmlsbDogI2UyMDAwZiB9IAoJPC9zdHlsZT4KCTxwYXRoIGlkPSJMYXllciIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGFzcz0iczAiIGQ9Im0yMSA4LjN2Ny40bC01LjMgNS4zaC03LjRsLTUuMy01LjN2LTcuNGw1LjMtNS4zaDcuNHptLTIgMC44bC00LjEtNC4xaC01LjhsLTQuMSA0LjF2NS44bDQuMSA0LjFoNS44bDQuMS00LjF6bS0yLjcgMC4xbC0yLjkgMi44IDIuOSAyLjktMS40IDEuNC0yLjktMi45LTIuOCAyLjktMS40LTEuNCAyLjgtMi45LTIuOC0yLjggMS40LTEuNCAyLjggMi44IDIuOS0yLjh6Ii8+Cjwvc3ZnPg==" })),
                        React.createElement("div", { className: "df-alert-message" },
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: safeHTML } }))));
                default:
                    return (React.createElement("div", null, "\u00A0"));
            }
        }
        else {
            return (React.createElement("div", null, "\u00A0"));
        }
    };
    DTCPage.prototype.render = function () {
        var productOptions = [
            {
                value: "none",
                title: "",
            },
            {
                value: "TTS",
                title: "TTS",
            },
            {
                value: "TGS",
                title: "TGS",
            },
            {
                value: "TTH",
                title: "TTH",
            },
            {
                value: "TGH",
                title: "TGH",
            },
            {
                value: "VTT",
                title: "VTT",
            },
            {
                value: "VTX",
                title: "VTX",
            },
        ];
        var regionOptions = [
            {
                value: "none",
                title: "",
            },
            {
                value: "North America",
                title: "North America",
            },
            {
                value: "South America",
                title: "South America",
            },
            {
                value: "Europe",
                title: "Europe",
            },
            {
                value: "China",
                title: "China",
            },
            {
                value: "Asia",
                title: "Asia",
            },
            {
                value: "Australia",
                title: "Australia",
            },
        ];
        var safeHTML = DOMPurify.sanitize(this.props.infoPanelText);
        var showInfo = this.props.showInfoSection;
        var alertType = this.props.infoPanelAlerts;
        return (React.createElement("div", { className: "df-container" },
            !this.props.listMode && (React.createElement("div", { className: "dtc-map-container " },
                this.showAlertPanel(safeHTML, showInfo, alertType),
                this.props.baiduMode ? (React.createElement(BMap_1.default, { techs: this.props.techs, filters: {
                        product: this.state.selectedProducts,
                        region: this.state.selectedRegions,
                    }, onMapMarkerClick: this.handleMapMarkerClick, openInfoIndex: this.state.openInfoIndex, geolocationCenter: this.state.geolocationCenter, geolocationZoom: this.state.geolocationZoom, boundsChanged: debounce(this.handleBoundsChangedBaidu.bind(this), 500, false) })) : (React.createElement(GMap_1.default, { mapElement: React.createElement("div", { style: { height: "100%" } }), loadingElement: React.createElement("div", { style: { height: "100%" } }), containerElement: React.createElement("div", { style: { height: "400px" } }), techs: this.props.techs, filters: {
                        product: this.state.selectedProducts,
                        region: this.state.selectedRegions,
                    }, onMapMarkerClick: this.handleMapMarkerClick, openInfoIndex: this.state.openInfoIndex, geolocationCenter: this.state.geolocationCenter, geolocationZoom: this.state.geolocationZoom, boundsChanged: debounce(this.handleBoundsChanged.bind(this), 500, false) })))),
            React.createElement("div", { className: "row dropdown-row", style: { marginTop: 20 } },
                React.createElement("div", { className: "col-md-3" },
                    React.createElement(Forms_1.FormDropdown, { name: "selectedProducts", onChange: this.handleProductChange, label: this.props.pageTranslations.SelectProduct, options: productOptions, value: this.state.selectedProducts })),
                React.createElement("div", { className: "col-md-3" },
                    React.createElement(Forms_1.FormDropdown, { name: "selectedRegions", onChange: this.handleRegionChange, label: this.props.pageTranslations.SelectRegion, options: regionOptions, value: this.state.selectedRegions })),
                React.createElement("div", { className: "col-md-3" },
                    React.createElement("button", { type: "submit", onClick: this.handleDropdownReset, className: "df-btn-primary", style: { marginBottom: 24, } }, this.props.pageTranslations.Reset))),
            React.createElement("div", null,
                React.createElement(DTCTechTable, { techs: this.state.techsInView, baiduMode: this.props.baiduMode, pageTranslations: this.props.pageTranslations, filters: {
                        product: this.state.selectedProducts,
                        region: this.state.selectedRegions,
                    } }))));
    };
    return DTCPage;
}(React.Component));
var element = document.getElementById("dtcTechRoot");
var root = (0, client_1.createRoot)(element);
root.render(React.createElement(DTCPage, { techs: techs, listMode: listMode, baiduMode: baiduMode, infoPanelText: infoPanelText, infoPanelAlerts: infoPanelAlerts, showInfoSection: showInfoSection, pageTranslations: pageTranslations }));
